<div
  class="card-wrapper"
  [id]="taskId"
  [ngClass]="{'visible': status, 'active': status===QuestionStatus.ACTIVE, 'shrink': shrink$ | async, 'position-relative': !(shrink$ | async)}"
>
  <div class="card-header">
    <ng-content select="[question]"></ng-content>
  </div>
  <div class="card-content">
    <div class="card-edit" [ngClass]="{'d-none': status!==QuestionStatus.ACTIVE}">
      <ng-content select="[input-options]"></ng-content>
    </div>
    <div
      class="card-answer"
      [ngClass]="{'show': status!==QuestionStatus.ACTIVE, 'edit': status===QuestionStatus.COMPLETE}"
      (click)="status===QuestionStatus.COMPLETE ? editAnswer() : null"
    >
      <ng-content select="[answer]"></ng-content>
      <div class="chat-loader" [ngClass]="{'show': status===QuestionStatus.LOADING}">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </div>
  <div class="card-footer" [ngClass]="{'d-none': status!==QuestionStatus.ACTIVE}">
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
